import { create } from 'zustand';
import {
  clearContentLabelCategoryIn,
  pruneContentLabelSelection,
  toggleContentLabelValueIn,
  type ContentLabelCatalog,
  type ContentLabelSelection,
} from './contentLabelFilterSelection';

// The Content tab's Content Labels v2 selection: category id -> value ids, Unlabeled as
// CONTENT_LABEL_NULL_BUCKET_ID and Need decision as CONTENT_LABEL_NEEDS_DECISION_ID.
// Kept apart from taxonomy-filter's legacy labelsFilter on purpose.
export type ContentLabelFilterState = {
  contentLabels: ContentLabelSelection;
  handleToggleContentLabelValue: (contentLabelCategoryId: string, valueId: string) => void;
  handleClearContentLabelCategory: (contentLabelCategoryId: string) => void;
  pruneContentLabels: (catalog: ContentLabelCatalog) => void;
  resetContentLabelFilters: () => void;
};

export const useContentLabelFilterStore = create<ContentLabelFilterState>((set) => ({
  contentLabels: new Map<string, Set<string>>(),

  handleToggleContentLabelValue: (contentLabelCategoryId, valueId) =>
    set((state) => toggleContentLabelValueIn(state, contentLabelCategoryId, valueId)),

  handleClearContentLabelCategory: (contentLabelCategoryId) =>
    set((state) => clearContentLabelCategoryIn(state, contentLabelCategoryId)),

  // Returning the same state object is what stops zustand notifying subscribers, so a prune that
  // drops nothing never re-renders the Content tab.
  pruneContentLabels: (catalog) =>
    set((state) => {
      const contentLabels = pruneContentLabelSelection(state.contentLabels, catalog);
      return contentLabels === state.contentLabels ? state : { contentLabels };
    }),

  resetContentLabelFilters: () => set({ contentLabels: new Map<string, Set<string>>() }),
}));
